import type { IntlShape } from 'react-intl';

import type { RemixDisabledReason } from '../malleableUiPluginType';

import { messages } from './messages';

/**
 * Returns the appropriate disabled tooltip message based on the reason remix is disabled.
 */
export const getRemixDisabledTooltip = (
	formatMessage: IntlShape['formatMessage'],
	reason?: RemixDisabledReason,
): string => {
	switch (reason) {
		case 'version-history':
			return formatMessage(messages.remixDisabledTooltipVersionHistory);
		case 'archived':
		default:
			return formatMessage(messages.remixDisabledTooltipArchived);
	}
};
